import React from 'react';

export default function Hero({ band }) {
    return (
        <section className="relative overflow-hidden bg-transparent text-white">
            <div className="max-w-6xl mx-auto px-6 py-20 flex flex-col md:flex-row items-center gap-2">
                
                <div className="w-full md:w-[2/3] flex-1">
                    <div className="aspect-[16/9] rounded-2xl overflow-hidden bg-transparent flex items-center justify-center">
                        <video
                            src={`https://api.palladium.rocks/videos_src/${band.video}`}
                            autoPlay
                            loop
                            muted
                            playsInline
                            controls
                            className="aspect-[16/9] w-full h-auto object-cover rounded-2xl"
                            >
                        </video>
                    </div>
                </div>
            </div>
        </section>
    );
}